import { Button, Grid, styled } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import "./ImageInput.css";
import CustomButton from "components/CustomButton";
import theme from "config/theme";
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const FileInput = ({ name, onChange, dark = false }) => {
  const handlerChange = (e) => {
    const file = e.target.files[0];
    onChange(file);
  };

  return (
    <Button
      component="label"
      role={undefined}
      startIcon={<CloudUploadIcon />}
      sx={{
        textTransform: 'none',
        backgroundColor: theme.button[dark ? 'dark' : 'light'].backgroundColor,
        color: theme.button[dark ? 'dark' : 'light'].color,
        height: '40px',
        minWidth: '150px',
        borderRadius: '25px',
        padding: '0 32px',
        fontWeight: 'bold',
        fontSize: '18px',
        border: theme.button[dark ? 'dark' : 'light'].border,
        '&:disabled': {
          border: theme.button[dark ? 'dark' : 'light'].border,
          backgroundColor: theme.button[dark ? 'dark' : 'light'].backgroundColor,
          color: theme.button[dark ? 'dark' : 'light'].color,
        }
      }}
    >
      {name}
      <VisuallyHiddenInput
        type="file"
        onChange={handlerChange}
      />
    </Button>
  );
};

export default FileInput;
